import {
  Component, ViewEncapsulation, ChangeDetectionStrategy,
  Input, Output, EventEmitter, ChangeDetectorRef, 
  OnInit, ViewChild, ElementRef, OnDestroy
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ScrollFormService } from '@reservation/services/scroll-form.service';
import { environment as ENV } from '@environment';

@Component({
  selector: 'app-form-currency-input',
  templateUrl: './form-currency-input.component.html',
  styleUrls: ['./form-currency-input.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FormCurrencyInputComponent implements OnInit, OnDestroy {

  @Input() placeholder: string;
  @Input() required: boolean;
  @Input() id: string;
  @Input() style: string;
  @Input() formControlSelector: string;
  @Input() form: UntypedFormGroup;
  @Input() isSubmitted: boolean = false;

  @ViewChild('inputData') public inputDataRef: ElementRef;

  @Output() inputChange: EventEmitter<number> = new EventEmitter();

  public inputValue: string | number = 0;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private logErrorOriginal: any = window.console.error;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private logWarnOriginal: any = window.console.warn;

  constructor(
    private scrollFormService: ScrollFormService,
    private changeDetector: ChangeDetectorRef) { }

  ngOnInit(): void {
    window.console.error = () => { };
    window.console.warn = () => { };
    this.inputValue = this.form && this.formControlSelector && this.form?.get(this.formControlSelector) ?
      this.form?.get(this.formControlSelector)?.value : 0;
  }

  ngOnDestroy(): void {
    window.console.error = this.logErrorOriginal;
    window.console.warn = this.logWarnOriginal;
  }

  get isEmptyPlaceholder(): boolean {
    return !this.placeholder;
  }

  get currencyCode(): string {
    return ENV.countryInfo.currency_code;
  }

  get isErrorActivate(): boolean {
    return this.isSubmitted && (this.priceIsEmpty || this.priceIsMaxError);
  }

  get priceIsEmpty(): boolean {
    return this.form?.get(this.formControlSelector) && this.form?.get(this.formControlSelector).errors ?
      !!this.form?.get(this.formControlSelector)?.errors?.['min'] : false;
  }

  get priceIsMaxError(): boolean {
    return this.form?.get(this.formControlSelector) && this.form?.get(this.formControlSelector).errors ?
      !!this.form?.get(this.formControlSelector)?.errors?.['max'] : false;
  }

  get errorMessage(): string {
    return this.priceIsEmpty ? 'MANDATORY_PRICE' : this.priceIsMaxError ? 'MANDATORY_MAX_PRICE' : 'MANDATORY_FIELD';
  }

  get errorPrice(): number {
    return this.priceIsEmpty ? 0 : this.priceIsMaxError ? Number(this.form?.get(this.formControlSelector)?.value) : 0;
  }

  get isActivate(): boolean {
    return !!this.form && !!this.formControlSelector && !!this.form?.get(this.formControlSelector) &&
      (this.form?.get(this.formControlSelector)?.value === 0 || !!this.form?.get(this.formControlSelector)?.value);
  }

  public focusInput(elementRef: ElementRef): void {
    this.scrollFormService.focusDirectActivate(elementRef);
  }

  public resetInput(): void {
    this.form?.patchValue({ [this.formControlSelector]: 0 });
    this.changeDetector.detectChanges();
  }

  public changeValue(value: string): void {
    const _value = value.replace(/[^0-9-]+/g, '');
    if (_value === '' || _value === null) this.resetInput();
    this.inputChange.emit(Number(_value));
  }
}
